import { createSlice } from "@reduxjs/toolkit"

const initialStateResultadoGrillaJuicio= {
  dataGrillaJuicio: []
}; 

export const resultadoGrillaJuicioSlice = createSlice({ 
  name: "resultadoGrillaJuicios", 
  initialState: initialStateResultadoGrillaJuicio, 
  reducers:{
    setResultadoGrilla: (state, action)=>{
      state.dataGrillaJuicio=action.payload
    },
    resetResultadoGrilla: (state) => {
      state.dataGrillaFactura=initialStateResultadoGrillaJuicio.dataGrillaJuicio
    }
  }
});

export const {resetResultadoGrilla, setResultadoGrilla} = resultadoGrillaJuicioSlice.actions
export default resultadoGrillaJuicioSlice.reducer
